<template>
  <div id="bottom-nav">
    <nav
      class="transparent"
      id="footer-nav"
      :style="[{ backgroundImage: 'url(' + CoolBar + ')' }]">
      <ul class="nav-items">
        <li>
          <router-link :to="{ path: '/' }" class="waves-effect">
            <i class="material-icons-outlined">home</i>
            <span class="a-span">HOME</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Account' }" class="waves-effect">
            <i class=" material-icons-outlined">account_circle</i>
            <span class="a-span">SETTINGS</span>
          </router-link>
        </li>
        <!-- <drop-down
          ref="dd"
          class="footer-nav-dropdown"
          trigger-classes="btn-floating btn-large waves-effect indigo accent-2 middle-icon" 
          :cover-trigger="false">
          <template #text>
            <i class="material-icons white-text">home</i>
          </template>
          <template #items>
            <div class="contents" style="padding:16px;">
              <div class="title-text grey-text text-darken-3">
                Assessments Navigation
              </div>
              <div class="drop-nav">
                <router-link :to="{name: s.route}" tag="a" style="cursor:pointer" class="single-item grey-text text-darken-3 waves-effect" v-for="(s, i) in surveys" :key="i">
                  <div class="quick-icon"><img :src="s.thumbnail" alt="" width="100%" /></div>
                  <div class="quick-title">{{s.title}}</div>
                </router-link>
              </div>
            </div>
          </template>
        </drop-down> -->

        <router-link :to="{name: 'Home'}"
          class="btn-floating btn-large waves-effect indigo accent-2 middle-icon">
          <i class="material-icons white-text">home</i>
        </router-link>
        <li class="right">
          <router-link :to="{name:'resourceCenter'}">
            <i class=" material-icons-outlined">emoji_objects</i>
            <span class="a-span">RESOURCES</span>
          </router-link>
        </li>
        <li class="right">
          <router-link :to="{query: {state: 'search' }}">
            <i class=" material-icons-outlined">auto_stories</i>
           <span class="a-span">DICTIONARY</span>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import DropDown from '@/components/DropDown'
import CoolBar from '@/assets/CoolBar.png'
import waterPpl from '@/assets/waterPpl@2x.png'
import windHazard from '@/assets/wind-hazard@2x.png'
import floodHazard from '@/assets/flood-hazard@2x.png'
export default {
  name: 'AppBottomTab',
  components: {
    DropDown
  },
  props: {},
  data() {
    return {
      surveys: [
        {
          key: "wind_hazard",
          title: "Wind Hazard",
          thumbnail: windHazard,
          route: "WindHazardSurvey",
          tag: 38,
        },
        {
          key: "flood_hazard",
          title: "Flood Hazard",
          thumbnail: floodHazard,
          route: "FloodHazardSurvey",
          tag: 39,
        },
        {
          key: "water_hazard",
          title: "Water Shortage Hazard",
          thumbnail: waterPpl,
          route: "WaterHazardSurvey",
          tag: 40,
        },
      ],
      showAppOptions: false,
      CoolBar,
    }
  },
  mounted() {},
  computed: {
    isLoginX() {
      return this.$store.state.User.isLogin;
    },
    showBarX() {
      return !["MyInfo", "WindHazardSurvey"].includes(this.$route.name);
    },
  },
  methods: {
    $_goTo(route) {
      if (this.$route.name !== route) this.$router.push({ name: route });
    },
  },
};
</script>
<style lang="scss" scoped>
#bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 72px;
  z-index: 999;
  nav {
    &#footer-nav {
      height: 72px;
      background-position: center -10px;
      box-shadow: none;
      background-repeat: no-repeat;
      ul {
        &.nav-items {
          position: relative;
          width: 100%;
          &::before {
            content: " ";
            position: absolute;
            top: 7px;
            background: white;
            height: 73px;
            width: calc(50% - 74px);
            z-index: 1;
          }
          &::after {
            content: " ";
            position: absolute;
            top: 7px;
            background: white;
            height: 73px;
            width: calc(50% - 74px);
            z-index: 1;
            right: 0;
          }
          li {
            z-index: 9;
            position: relative;
            width: calc(20% - 10px);
            a {
              line-height: 72px;
              margin-top: 7px;
              width: 100%;
              text-align: center;
              position: relative;
              i {
                line-height: 52px;
                color: grey;
              }
              &.router-link-exact-active {
               i {
                 color: #536dfe !important;
               }
               &::before {
                content: ' ';
                width: 100%;
                background: #536dfe;
                position: absolute;
                left: 0;
                top: 0;
                height: 4px;
              }
             }
             span.a-span {
                color: black;
                font-size: 11px;
                @media screen and (max-width: 680px) {
                   font-size: 10px;
                }
                text-align: center;
                position: absolute;
                left: 0;
                right: 0;
                bottom: -14px;
            }
            }
          }
        }
      }
    }
  }
}
.contents {
  &:focus {
    outline: none !important;
  }
}
.title-text {
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 0 10px;
  line-height: 24px;
  margin-bottom: 6px;
}
</style>
<style lang="scss">
  .middle-icon {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -6px);
  }
  .drop-nav {
    display: inline-flex;
    flex-wrap: wrap;
    line-height: 1;
    .single-item {
      width: 100%;
      margin: 0 8px 8px;
      border-radius: 24px;
      padding: 6px 8px;
      border: 1px solid #e9e9e9;
    }
    .quick-icon {
      float:left;
      width: 48px;
     img {
      width: 80%;
      margin: auto;
     }
    }
    .quick-title {
      line-height: 32px;
      font-size: 12px;
      margin: 0 0 0px 6px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: black;
    }
}

</style>